/* AppStore.tsx */
import { Dashboard, screenType } from "model/Datatypes";
import React, { useDebugValue } from "react";

export type AppState = Dashboard & screenType;

const initialState: AppState = {
  backgroundImgUrl: "",
  cmProjectID: "",
  siteName: "",
  projectLoaded: false,
  siteDescription: "",
  pages: [],
  site: "",
  type: "WIDE",
};

type Action =
  | { type: "SELECT_SITE"; payload: AppState }
  | { type: "SET_SCREEN_TYPE"; payload: screenType };

const reducer = (state: AppState, action: Action) => {
  console.log({ action });
  switch (action.type) {
    case "SELECT_SITE":
      return action.payload;
    case "SET_SCREEN_TYPE":
      return { ...state, screenType: action.payload.type };
    default:
      return state;
  }
};

type AppStateContext = {
  state: AppState;
  dispatch: React.Dispatch<Action>;
};
//@ts-ignore - ignore to avoid passing a default argument.
export const store = React.createContext<AppStateContext>();
const { Provider } = store;

export const StateProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

//Here's three helper hooks to make access simple:
export const useGlobalStore = () => {
  const { state, dispatch } = React.useContext(store);
  return { state, dispatch };
};
export const useGlobalState = () => {
  const { state } = React.useContext(store);
  useDebugValue("Global state hook");
  return state;
};
export const useGlobalDispatch = () => {
  const { dispatch } = React.useContext(store);
  return dispatch;
};
